// import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { useFormik } from "formik";
import { useSnackbar } from "notistack";
import React from "react";
import { Link } from "react-router-dom";
import * as yup from "yup";
import API from "@/api/serverCall";
import Button from "@/components/Button";
import { useTranslation } from "react-i18next";

export default function Forgot() {
	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();
	const sendMail = (email: string) => {
		// for loading
		try {
			const requestData = {
				email,
			};
			API.POST<string>({
				link: `/user/signIn/resetPassword`, // 두잉랩서버 로그인토큰발급 api임
				body: requestData,
				loginRequest: true,
			})
				.then((response) => {
					enqueueSnackbar(`계정복구 지침이 ${email}으로 전송되었습니다.`, {
						variant: "info",
					});
				})
				.catch((error) => {
					if (error.response.status === 400 || error.response.status === 404) {
						enqueueSnackbar("존재하지 않는 회원입니다", {
							variant: "info",
						});
					} else {
						enqueueSnackbar("일시적 오류입니다", {
							variant: "info",
						});
					}
				});
		} catch (error) {
			console.error(error);
		}
	};

	const validationSchema = yup.object({
		email: yup.string().email("Enter a valid email").required("Email is required"),
	});
	const formik = useFormik({
		initialValues: {
			nameFirst: "",
			nameLast: "",
			email: "",
			password: "",
		},
		validationSchema,
		onSubmit: (values) => {
			sendMail(values.email);
		},
	});
	return (
		<div
			style={{
				width: "35rem",
				margin: "10rem  auto ",
				display: "flex",
				flexDirection: "column",
				textAlign: "center",
			}}
		>
			<form onSubmit={formik.handleSubmit}>
				<h1 style={{ marginBottom: "3rem" }}>
					{t("login.password_recovery_title")}
				</h1>
				<Box sx={{ width: "100%", typography: "body1", margin: "auto" }}>
					<div>
						<div>
							<Box
								sx={{
									maxWidth: "100%",
									marginBottom: "1rem",
								}}
							>
								<TextField
									fullWidth
									helperText={t("login.password_recovery_guide")}
									id="email"
									name="email"
									label="email"
									value={formik.values.email}
									onChange={formik.handleChange}
									error={
										formik.touched.email &&
										Boolean(formik.errors.email)
									}
								/>
							</Box>
							<Button
								variant="contained"
								backgroundColor="#0071E3"
								sx={{
									height: "3.5rem",
									marginBottom: "2rem",
									fontWeight: "bold",
									fontSize: "1.2rem",
								}}
								fullWidth={true}
								type="submit"
							>
								{t("login.password_recovery_send_mail")}
							</Button>
						</div>

						<Link to="/auth/login" style={{ color: "#0071E3" }}>
							{t("login.password_recovery_back_to_the_login")}
						</Link>
					</div>
				</Box>
			</form>
		</div>
	);
}
